import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Landing } from "@/pages/Landing";
import { AuthPage } from "@/pages/AuthPage";
import { SoulKeys } from "@/pages/SoulKeys";
import { SoulKeyDetail } from "@/pages/SoulKeyDetail";
import { SoulKeyChat } from "@/pages/SoulKeyChat";
import { Admin } from "@/pages/Admin";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route path="/app" element={<SoulKeys />} />
          <Route path="/soulkey/:id" element={<SoulKeyDetail />} />
          <Route path="/soulkey/:id/chat" element={<SoulKeyChat />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
